import DrumRollPicker from "./DrumRollPicker";

function MealTimePickerModal({
  activeMealTimePicker,
  setActiveMealTimePicker,
  modalOverlayStyle,
  isMobile,
  appTheme,
  saveMealTime,
  tempHour,
  setTempHour,
  tempMinute,
  setTempMinute,
  tempPeriod,
  setTempPeriod
}) {
  if (!activeMealTimePicker) return null;

  return (
    <div
      style={{
        ...modalOverlayStyle,
        alignItems: "flex-end",
        padding: "0",
        zIndex: 2000
      }}
      onClick={() => setActiveMealTimePicker(null)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          maxWidth: "100vw",
          borderRadius: "28px 28px 0 0",
          background: appTheme.elevatedBackground,
          border: appTheme.cardBorder,
          backdropFilter: "blur(18px) saturate(180%)",
          WebkitBackdropFilter: "blur(18px) saturate(180%)",
          boxShadow: "0 -10px 40px rgba(15,23,42,0.16)",
          padding: "20px 20px 40px",
          animation: "fadeInModal 0.22s ease"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px"
          }}
        >
          <button
            onClick={() => setActiveMealTimePicker(null)}
            style={{
              padding: "8px 16px",
              borderRadius: "999px",
              border: appTheme.pillBorder,
              background: appTheme.pillBackground,
              color: appTheme.primaryText,
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer"
            }}
          >
            Cancel
          </button>

          <div
            style={{
              fontSize: "17px",
              fontWeight: "700",
              color: appTheme.primaryText,
              textTransform: "capitalize",
              fontFamily: appTheme.fontHeading
            }}
          >
            {activeMealTimePicker} time
          </div>

          <button
            onClick={saveMealTime}
            style={{
              padding: "8px 16px",
              borderRadius: "999px",
              border: "none",
              background: appTheme.accentColor,
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "14px",
              cursor: "pointer"
            }}
          >
            Save
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "8px",
            background: appTheme.softBackground,
            borderRadius: "20px",
            border: appTheme.cardBorder,
            padding: "8px",
            overflow: "hidden"
          }}
        >
          <DrumRollPicker
            values={["1","2","3","4","5","6","7","8","9","10","11","12"]}
            selected={tempHour}
            onSelect={setTempHour}
            appTheme={appTheme}
          />

          <DrumRollPicker
            values={["00","05","10","15","20","25","30","35","40","45","50","55"]}
            selected={tempMinute}
            onSelect={setTempMinute}
            appTheme={appTheme}
          />

          <DrumRollPicker
            values={["AM","PM"]}
            selected={tempPeriod}
            onSelect={setTempPeriod}
            appTheme={appTheme}
          />
        </div>

        <div
          style={{
            marginTop: "14px",
            textAlign: "center",
            fontSize: "13px",
            color: appTheme.secondaryText
          }}
        >
          Scroll to set your {activeMealTimePicker} reminder time
        </div>
      </div>
    </div>
  );
}

export default MealTimePickerModal;